import { decrypt, encrypt } from '@/utils/jsencrypt'

const AccessTokenKey = 'ACCESS_TOKEN'
const RefreshTokenKey = 'REFRESH_TOKEN'
const TenantIdKey = 'tenantId'
const LoginFormKey = 'loginForm'

// ========== Token 相关 ==========

// 获取 Token
export function getAccessToken() {
  return uni.getStorageSync(AccessTokenKey)
}

// 获取 RefreshToken
export function getRefreshToken() {
  return uni.getStorageSync(RefreshTokenKey)
}

// 设置 Token
export function setToken(token) {
  uni.setStorageSync(AccessTokenKey, token.accessToken)
  uni.setStorageSync(RefreshTokenKey, token.refreshToken)
}

// 移除 Token
export function removeToken() {
  uni.removeStorageSync(AccessTokenKey)
  uni.removeStorageSync(RefreshTokenKey)
}

// ========== 租户相关 ==========

export const getTenantId = () => {
  return uni.getStorageSync(TenantIdKey)
}

export const setTenantId = (username: string) => {
  uni.setStorageSync(TenantIdKey, username)
}

// ========== 账号相关 ==========

export type LoginFormType = {
  tenantName: string
  username: string
  password: string
  rememberMe: boolean
}

export const getLoginForm = () => {
  const loginForm: LoginFormType = uni.getStorageSync(LoginFormKey)
  if (loginForm) {
    loginForm.password = decrypt(loginForm.password) as string
  }
  return loginForm
}

export const setLoginForm = (loginForm: LoginFormType) => {
  loginForm.password = encrypt(loginForm.password) as string
  uni.setStorageSync(LoginFormKey, loginForm)
}

export const removeLoginForm = () => {
  uni.removeStorageSync(LoginFormKey)
}
